module.exports = __webpack_public_path__ + "static/extra_3_mobile-74f9f8a8ef062052eaa49ad42829f944.jpg";